import { projectCategories } from '../data/projects';
import type { Project, ProjectCategory } from '../types/content';

export type CategoryFilter = ProjectCategory['id'];

export function categoryLabel(id: CategoryFilter) {
  return projectCategories.find((category) => category.id === id)?.label ?? 'Project';
}

export function isCategoryFilter(value: string | null): value is CategoryFilter {
  return projectCategories.some((category) => category.id === value);
}

export function filterProjects(list: Project[], category: CategoryFilter, query = '') {
  const q = query.trim().toLowerCase();
  return list.filter((project) => {
    if (category !== 'all' && project.category !== category) return false;
    if (!q) return true;
    const haystack = [project.title, project.location, project.client, project.summary, ...project.scope]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return haystack.includes(q);
  });
}

export function countByCategory(list: Project[]) {
  const counts: Record<string, number> = { all: list.length };
  list.forEach((project) => {
    counts[project.category] = (counts[project.category] ?? 0) + 1;
  });
  return counts;
}
